import * as jQuery from 'jquery'

jQuery.fn.uppercaseWords = function () {
    return this.each(function () {
        let val = jQuery(this).text(), newVal = '';
        val = val.split(' ');

        for (let c = 0; c < val.length; c++) {
            newVal += val[c].substring(0, 1).toUpperCase() + val[c].substring(1, val[c].length).toLowerCase() + (c + 1 === val.length ? '' : ' ');
        }
        jQuery(this).text(newVal);
    });
};